import React from "react";

const LegacyComponent = ({ legaciesData }) => {
  const data = legaciesData?.data;

  return (
    <div className="p-6 flex items-center justify-center mt-20">
      {data && data.length > 0 ? (
        <table className="w-1/2 border-collapse text-center">
          <thead>
            <tr className="border-b border-white text-secondary font-bold">
              <th className="py-2">Legacy</th>
              {data.map((legacy, index) => (
                <th key={index} className="py-2">{legacy.legacy_name}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data[0]?.data?.length > 0 ? (
              data[0].data.map((_, rowIndex) => (
                <tr key={rowIndex}>
                  <td className="py-2"></td>
                  {data.map((legacy, colIndex) => (
                    <td key={colIndex} className="py-2">
                      {legacy.data[rowIndex]?.item_name || "-"}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              // If no row data is available
              <tr>
                <td colSpan={data.length + 1} className="py-4 text-center text-gray-500">
                  No Data Available
                </td>
              </tr>
            )}

            <tr className="border-b border-white font-bold">
              <td className="py-2">Total</td>
              {data.map((legacy, index) => (
                <td key={index} className="py-2 text-secondary">
                  {legacy.total_initial_amount || "-"}
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      ) : (
        // Show "No Data Available" when the main data array is empty
        <div className="text-center text-gray-500 text-lg">No Data Available</div>
      )}
    </div>
  );
};

export default LegacyComponent;
